import { createBeat } from "@kosmod/kit";

export const renderBeat = createBeat();
export const inputBeat = createBeat();
